'use client';
import { PostCardComp } from 'components';
import { useMemo, useState } from 'react';
import styles from './relatedPosts.module.scss';
import { __FetchRelatedPosts } from './relatedPosts.script';
import { __RelatedPostsPropsType } from './relatedPosts.type';
import { Input, Spin } from 'antd';
import { useQuery } from '@tanstack/react-query';

export default function RelatedPostsComp(props: __RelatedPostsPropsType) {
    const [search, setSearch] = useState('');
    const queryKey = useMemo(() => ['posts', 'related', props.slug] as const, [props.slug]);
    const query = useQuery({
        queryKey,
        queryFn: () => __FetchRelatedPosts(props.slug),
        staleTime: 30 * 60 * 1000,
    });
    const posts = query.data;

    if (!posts) {
        if (query.isPending) {
            return (
                <section className={styles.section}>
                    <h3 className={`t-h3 t-l-black1 t-d-gray3 t-500 ${styles.title}`}>آگهی‌های دیگر این فروشگاه</h3>
                    <div className={`center-content ${styles.loading}`}>
                        <Spin />
                    </div>
                </section>
            );
        }
        return null;
    }

    if (!posts.length) return null;

    return (
        <section className={styles.section}>
            <h3 className={`t-h3 t-l-black1 t-d-gray3 t-500 ${styles.title}`}>آگهی‌های دیگر این فروشگاه</h3>
            <Input
                className={`mb-4-i ${styles['search-input']}`}
                placeholder="جستجو ..."
                onChange={(e) => setSearch(e.target.value)}
            />
            <div className={styles.posts}>
                {posts
                    .filter((item) => item.title.includes(search))
                    .sort((a, b) => {
                        const date_a = a.renewed_at ?? a.created_at;
                        const date_b = b.renewed_at ?? b.created_at;
                        return new Date(date_b).getTime() - new Date(date_a).getTime();
                    })
                    .map((item) => (
                        <PostCardComp key={item.id} data={item} />
                    ))}
                <span />
            </div>
        </section>
    );
}
